"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
export default function StudioFooter() {
  return <footer id="footer" className="bg-[#0a2540] px-6 py-20 text-white/60 md:px-16">
      <div className="mx-auto mb-14 grid max-w-7xl gap-12 md:grid-cols-4">
        <div>
          <Link to="/#" className="font-serif text-2xl font-bold tracking-tight text-[#028090]">
            Kolay<span className="text-white">Health</span>
          </Link>

          <p className="mt-4 max-w-xs text-sm leading-7 text-white/45">
            Simplifying healthcare navigation for people who need care without
            the friction of portals, calls, and scheduling back-and-forth.
          </p>

          <p className="mt-4 font-serif text-sm italic text-white/30">
            May it be easy for you.
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-white/35">
            Product
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="#patients" className="transition-colors hover:text-[#02C39A]">
                For Patients
              </Link>
            </li>
            <li>
              <Link to="#providers" className="transition-colors hover:text-[#02C39A]">
                For Providers
              </Link>
            </li>
            <li>
              <Link to="#how" className="transition-colors hover:text-[#02C39A]">
                How It Works
              </Link>
            </li>
            <li>
              <Link to="#contact" className="transition-colors hover:text-[#02C39A]">
                Get Started
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-white/35">
            Company
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/#" className="transition-colors hover:text-[#02C39A]">
                About Us
              </Link>
            </li>
            <li>
              <Link to="#contact" className="transition-colors hover:text-[#02C39A]">
                Contact
              </Link>
            </li>
            <li>
              <Link to="/careers" className="transition-colors hover:text-[#02C39A]">
                Careers
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-white/35">
            Legal
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/privacy-policy" className="transition-colors hover:text-[#02C39A]">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms-of-service" className="transition-colors hover:text-[#02C39A]">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/hipaa-compliance" className="transition-colors hover:text-[#02C39A]">
                HIPAA Compliance
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto flex max-w-7xl flex-col gap-3 border-t border-white/10 pt-8 text-sm text-white/30 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} KolayHealth. All rights reserved.</span>
        <span>Simplifying Healthcare Navigation</span>
      </div>
    </footer>;
}